// Mirrors CreateProblemReportDto in bciti-back-end-organisation (src/problem-report/dto).

export const CITY_WEBSITE_MODULE_KEY = 'city-website';
export const OTHER_MODULE_KEY = 'other';

export type ReportReferenceKind = 'request' | 'permit' | 'citizen';

export interface ReportReference {
    kind: ReportReferenceKind;
    id: string;
}

export interface RecordedError {
    kind: 'http' | 'js';
    method?: string;
    path?: string;
    status?: number;
    message: string;
    at: string;
}

export interface ReportModule {
    key: string;
    label: string;
}

export interface ReportAttachment {
    url: string;
    originalName: string;
}

export interface ReportContext {
    page: { path: string; references: ReportReference[] };
    admin: { id: string; name: string; email: string; roles: string[] };
    env: string;
    lang: string;
    browser: { userAgent: string; viewport: string; screen: string; timezone: string };
    openedAt: string;
    recentErrors: RecordedError[];
}

/** Everything captured when the dialog opens; picking another module never changes it. */
export interface ReportSnapshot {
    context: ReportContext;
    organisation: { tag: string; name: string };
    detectedModule: ReportModule;
    modules: ReportModule[];
}

export interface CreateProblemReportRequest {
    description: string;
    blocking: boolean;
    module: ReportModule & { detectedKey: string };
    attachments: ReportAttachment[];
    context: ReportContext;
}

export interface ProblemReportCreated {
    key: string;
}
